import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent, initPixel } from "@/lib/fbpixel";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(() => getConsent() === null);

  const decide = (value) => {
    setConsent(value);
    if (value === "granted") initPixel();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="consent-banner"
          className="fixed inset-x-0 bottom-0 z-[70] border-t border-cognac/40 bg-espresso px-5 py-5 md:px-10"
        >
          <div className="mx-auto flex max-w-6xl flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-8">
            <p className="font-body text-sm leading-[1.6] text-gold/85 md:max-w-2xl">
              Um Deine Erfahrung auf unserer Website optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies und ähnliche Technologien wie den Meta-Pixel. Manche davon sind technisch notwendig, andere helfen uns, das Angebot zu verbessern und Dir relevante Inhalte zu zeigen. Mehr dazu in unserer{" "}
              <a
                href="https://luisabergholz.com/datenschutzerklaerung"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="consent-privacy-link"
                className="underline underline-offset-2 transition-colors duration-300 hover:text-gold"
              >
                Datenschutzerklärung
              </a>
              .
            </p>
            <div className="flex shrink-0 items-center gap-3">
              <button
                onClick={() => decide("denied")}
                data-testid="consent-decline-btn"
                className="rounded-full border border-gold/40 px-6 py-2.5 font-heading text-xs font-600 uppercase tracking-[0.16em] text-gold/80 transition-colors duration-300 hover:border-gold hover:text-gold"
                style={{ fontWeight: 600 }}
              >
                Nur notwendige
              </button>
              <button
                onClick={() => decide("granted")}
                data-testid="consent-accept-btn"
                className="rounded-full bg-gold px-6 py-2.5 font-heading text-xs font-600 uppercase tracking-[0.16em] text-espresso transition-colors duration-300 hover:bg-cognac-light"
                style={{ fontWeight: 600 }}
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
